import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

import { scheduleApi } from "@shared/apis"
import { WownetExecuteLink } from "@shared/components"
import { Schedule, useSchedule } from "@shared/contexts"
import { subtractToYYYYMMDD, toYYYYMMDD } from "@shared/modules"
import { Pagination } from "@shared/types"

import dayjs from "dayjs"

import ListTable from "./ListTable"

export default function Schedules() {
  const { streamerName } = useParams<{ streamerName?: string }>()
  const { schedule } = useSchedule()

  const [schedules, setSchedules] = useState<Pagination<Schedule>>({
    content: [],
    number: 0,
    totalPages: 0,
  })
  const [isLoaded, setIsLoaded] = useState(false)

  const paymentInformation = schedule?.paymentInformation

  useEffect(() => {
    if (!streamerName || !paymentInformation) return

    const startDate = subtractToYYYYMMDD(new Date(), 14, "day")
    const endDate = toYYYYMMDD(new Date())

    scheduleApi
      .get(streamerName, paymentInformation, true, 1, 5, startDate, endDate)
      .then(({ data }) => {
        const { content: schedules, number, totalPages } = data
        setSchedules((prevSchedules) => ({
          number,
          totalPages,
          content: [
            ...prevSchedules.content,
            ...schedules.filter((value) => schedule?.id !== value.id),
          ],
        }))
        setIsLoaded(true)
      })
  }, [streamerName, paymentInformation])

  return (
    <ListTable
      colWidths={[80, "*", 50]}
      headers={["날짜", "프로그램 명", "보기"]}
    >
      {isLoaded && !schedules.content.length && (
        <tr>
          <td
            colSpan={3}
            className="center"
            style={{ height: 60, color: "#999", fontSize: 13 }}
          >
            시청 가능한 녹화방송이 존재하지 않습니다.
          </td>
        </tr>
      )}
      {schedules.content.map((schedule, i) => (
        <tr key={i}>
          <td className="center">
            {dayjs(schedule.createdAt).format("YYYY-MM-DD")}
          </td>
          <td className="lAlign">{schedule.title}</td>
          <td className="center">
            <span className={"ty01"}>
              {/* 와우넷 홈페이지에서 VOD 클릭 시 동작 방식
              그대로 사용하도록 코드 수정 */}
              <WownetExecuteLink scheduleId={schedule.id} title="보기" />
            </span>
          </td>
        </tr>
      ))}
    </ListTable>
  )
}
